module Meevo.Components.Controls {
    'use strict';

    export class MeevoDuration implements angular.IDirective {
        scope = {
            ngModel: '=ngModel',
            contentKey: '@',
            disabled: '=ngDisabled',
            changed: '&ngChange',
            tabIndex: '=tabIndex',
            required: "=ngRequired",
            includeZero: "=?",
            maxIntervals: "=?",
            maxMinutes: "=?",
            minIntervals: "=?",
            minMinutes: "=?",
            showMinutes: "=?",
            intervalsApi: "@?",
            name: "@",
            offsetMinutes: "=?",
        }

        templateUrl = 'app/components/controls/duration/durationTemplate.html';

        private maximumMinutes = 12 * 60; // 12 hours
        private minimumIncrementMinutes = 5; // 5 minutes

        getMaxInterval(maxMinutes, maxIntervals, increment) {
            if (angular.isDefined(maxMinutes)) {
                return maxMinutes;
            }
            else if (angular.isDefined(maxIntervals)) {
                return maxIntervals * increment;
            } else {
                return this.maximumMinutes;
            }
        }

        getMinInterval(minMinutes, minIntervals, increment) {
            if (angular.isDefined(minMinutes)) {
                return minMinutes;
            }
            else if (angular.isDefined(minIntervals)) {
                return minIntervals * increment;
            } else {
                return 0;
            }
        }

        getAppointmentBookINcrementNumber() {
            let appointmentBookIncrementNumber = 15;
            switch (this.$rootScope.appointmentBookSettings.appointmentBookPrecisionIncrement) {
                case Meevo.Model.AppointmentIncrementEnum.Min5:
                    appointmentBookIncrementNumber = 5;
                    break;
                case Meevo.Model.AppointmentIncrementEnum.Min10:
                    appointmentBookIncrementNumber = 10;
                    break;
            }
            return appointmentBookIncrementNumber;
        }

        link(scope: any, element: JQuery, attrs: angular.IAttributes) {
            if (angular.isUndefined(scope.includeZero)) {
                scope.includeZero = true;
            }
            if (angular.isUndefined(scope.showMinutes)) {
                scope.showMinutes = true;
            }
            if (angular.isUndefined(scope.offsetMinutes)) {
                scope.offsetMinutes = 0;
            }

            if (scope.intervalsApi) {
                scope.validIntervals = [];
                this.dataService.customMethodData(scope.intervalsApi, "GET", {}).then(response=> {
                    scope.validIntervals = response.data;
                });
            }

            const appointmentBookIncrementNumber = this.getAppointmentBookINcrementNumber();
            const minInterval = this.getMinInterval(scope.minMinutes, scope.minIntervals, appointmentBookIncrementNumber);
            const maxInterval = this.getMaxInterval(scope.maxMinutes, scope.maxIntervals, appointmentBookIncrementNumber);

            scope.intervals = [];

            const start = scope.includeZero ? 0 : this.minimumIncrementMinutes;
            for (let i = start; i <= this.maximumMinutes; i += this.minimumIncrementMinutes) {
                scope.intervals.push(i);
            }

            scope.hideInterval = (interval) => {
                if (!angular.isDefined(interval)) {
                    return false;
                }

                if (interval < minInterval || interval > maxInterval || interval % appointmentBookIncrementNumber !== 0) {
                    return true;
                }

                if (angular.isDefined(scope.validIntervals) && scope.validIntervals.indexOf(interval) === -1) {
                    return true;
                }

                return false;
            }

            scope.getDisplay = (interval: number): string => {
                if (angular.isUndefined(interval)) {
                    return "";
                }

                const adjustedInterval = interval + scope.offsetMinutes;

                if (scope.showMinutes) {
                    return adjustedInterval;
                }

                const minutes = adjustedInterval % 60
                const hours = (adjustedInterval - minutes) / 60;
                let time = `${minutes}m`;
                if (hours > 0) {
                    time = `${hours}h ${minutes > 0 ? time : ''}`;
                }
                return time;
            }
        }

        constructor(private $rootScope,
            private dataService: Meevo.Components.BaseClasses.IDataService) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: any, dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoDuration($rootScope, dataService);
            };
            directive.$inject = [
                "$rootScope",
                "meevo.components.common.DataService"
            ];

            return directive;
        }
    }
    angular.module('meevo.components.controls')
        .directive('meevoDuration', MeevoDuration.factory());
}